/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Camera} from "../model/camera";
import {CameraCommandResult} from "../model/camera-command-result";
import {CameraProxyType} from "../model/camera-proxy-type";
import {CameraResolution} from "../model/camera-resolution";
import {CameraResolutionType} from "../model/camera-resolution-type";
import {DeviceType} from "../model/device-type";
import {FocusCameraRequest} from "../model/focus-camera-request";
import {GetCameraParametersResponse} from "../model/get-camera-parameters-response";
import {ListData} from "../model/list-data";
import {PtzAbsoluteZoomRequest} from "../model/ptz-absolute-zoom-request";
import {PtzCenterRequest} from "../model/ptz-center-request";
import {PtzClearHomePositionRequest} from "../model/ptz-clear-home-position-request";
import {PtzContinousZoomRequest} from "../model/ptz-continous-zoom-request";
import {PtzContinuousPanTiltMoveRequest} from "../model/ptz-continuous-pan-tilt-move-request";
import {PtzGoToHomePositionRequest} from "../model/ptz-go-to-home-position-request";
import {PtzRelativeZoomRequest} from "../model/ptz-relative-zoom-request";
import {PtzRemoveHomePositionRequest} from "../model/ptz-remove-home-position-request";
import {PtzSetCurrentPositionAsHomePresetRequest} from "../model/ptz-set-current-position-as-home-preset-request";
import {PtzSetCurrentPositionAsPrivacyPresetRequest} from "../model/ptz-set-current-position-as-privacy-preset-request";
import {PtzSetHomePositionRequest} from "../model/ptz-set-home-position-request";
import {RestartCameraRequest} from "../model/restart-camera-request";
import {RotateCamera180Request} from "../model/rotate-camera180-request";
import {SupportedCameraResolution} from "../model/supported-camera-resolution";
import {UpdateAllCameraConfigurationsRequest} from "../model/update-all-camera-configurations-request";
import {UpdateAllCameraResolutionsOfTypeRequest} from "../model/update-all-camera-resolutions-of-type-request";
import {UpdateAllCameraResolutionsRequest} from "../model/update-all-camera-resolutions-request";
import {UpdateAllCamerasOfSameTypeRequest} from "../model/update-all-cameras-of-same-type-request";
import {UpdateRecorderConfigurationResponse} from "../model/update-recorder-configuration-response";
import {VideoDestinationFormat} from "../model/video-destination-format";
import {VideoSourceFormat} from "../model/video-source-format";
import {WebCameraView} from "../model/web-camera-view";
import {ZoomInCameraRequest} from "../model/zoom-in-camera-request";
import {ZoomOutCameraRequest} from "../model/zoom-out-camera-request";

@Injectable({
    providedIn: "root",
})
export class SimCameraService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public discoverOnvifDevices() {
        return super.post<Camera[]>(`/api/Camera/DiscoverOnvifDevices`, {});
    }

    public focusCamera(request: FocusCameraRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/FocusCamera`, request);
    }

    public getAxisActivXObjectMarkup(cameraUrl: string, file: string, displayWidth: number, displayHeight: number) {
        return super.get<void>(`/api/Camera/GetAxisActivXObjectMarkup`, {cameraUrl: cameraUrl, file: file, displayWidth: displayWidth, displayHeight: displayHeight});
    }

    public getCameraById(cameraId: string) {
        return super.get<WebCameraView>(`/api/Camera/GetCameraById`, {cameraId: cameraId});
    }

    public getCameraByIds(cameraIds: string[]) {
        return super.post<WebCameraView[]>(`/api/Camera/GetCameraByIds`, cameraIds);
    }

    public getCameraReport_Url(cameraId: string) {
        return super.getUrl(`/api/Camera/GetCameraReport`, {cameraId: cameraId});
    }

    public getCameraResolutions(cameraId: string) {
        return super.get<SupportedCameraResolution[]>(`/api/Camera/GetCameraResolutions`, {cameraId: cameraId});
    }
/**
 * @deprecated GetCameras is deprecated, please use GetWebCameras instead.This method is still used in the old settings and should be removed when the new settings are done.
 */ 

    public getCameras(includeUnlicensedCameras: boolean = false) {
        return super.get<WebCameraView[]>(`/api/Camera/GetCameras`, {includeUnlicensedCameras: includeUnlicensedCameras});
    }

    public getCamerasByFilter(deviceType: DeviceType, sourceFormat: VideoSourceFormat, destinationFormat: VideoDestinationFormat, proxyType: CameraProxyType) {
        return super.get<Camera[]>(`/api/Camera/GetCamerasByFilter`, {deviceType: deviceType, sourceFormat: sourceFormat, destinationFormat: destinationFormat, proxyType: proxyType});
    }

    public getCameraStream(cameraId: string, cameraResolutionType: CameraResolutionType) {
        return super.get<string>(`/api/Camera/GetCameraStream`, {cameraId: cameraId, cameraResolutionType: cameraResolutionType});
    }

    public getCameraToken(cameraId: string) {
        return super.get<string>(`/api/Camera/GetCameraToken`, {cameraId: cameraId});
    }

    public getCurrentCameraParameters(cameraId: string) {
        return super.get<GetCameraParametersResponse>(`/api/Camera/GetCurrentCameraParameters`, {cameraId: cameraId});
    }

    public getDefaultCameraResolutions() {
        return super.get<CameraResolution[]>(`/api/Camera/GetDefaultCameraResolutions`, );
    }

    public getWebCameras(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number, includeUnlicensedCameras: boolean = false) {
        return super.get<ListData<WebCameraView>>(`/api/Camera/GetWebCameras`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize, includeUnlicensedCameras: includeUnlicensedCameras});
    }

    public ptzCenter(request: PtzCenterRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZCenter`, request);
    }

    public ptzClearHomePosition(request: PtzClearHomePositionRequest) {
        return super.post<boolean>(`/api/Camera/PTZClearHomePosition`, request);
    }

    public ptzContinousZoom(request: PtzContinousZoomRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZContinousZoom`, request);
    }

    public ptzContinuousPanTiltMove(request: PtzContinuousPanTiltMoveRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZContinuousPanTiltMove`, request);
    }
/**
 * http://cam90.simstation.com/axis-cgi/com/ptz.cgi?query=presetposall
 */ 

    public ptzGetHomePositions(cameraId: string) {
        return super.get<number[]>(`/api/Camera/PTZGetHomePositions`, {cameraId: cameraId});
    }

    public ptzGoToHomePosition(request: PtzGoToHomePositionRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZGoToHomePosition`, request);
    }

    public ptzRelativeZoom(request: PtzRelativeZoomRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZRelativeZoom`, request);
    }

    public ptzRemoveHomePosition(request: PtzRemoveHomePositionRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZRemoveHomePosition`, request);
    }

    public ptzSetHomePosition(request: PtzSetHomePositionRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/PTZSetHomePosition`, request);
    }

    public removeCamera(camera: Camera) {
        return super.post<boolean>(`/api/Camera/RemoveCamera`, camera);
    }

    public restartCamera(request: RestartCameraRequest) {
        return super.post<boolean>(`/api/Camera/RestartCamera`, request);
    }

    public rotateCamera180(request: RotateCamera180Request) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/Camera/RotateCamera180`, request);
    }

    public setCurrentPositionAsHomePreset(request: PtzSetCurrentPositionAsHomePresetRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/SetCurrentPositionAsHomePreset`, request);
    }

    public setCurrentPositionAsPrivacyPreset(request: PtzSetCurrentPositionAsPrivacyPresetRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/SetCurrentPositionAsPrivacyPreset`, request);
    }

    public setDeviceDefaultsForCamera(camera: Camera) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/Camera/SetDeviceDefaultsForCamera`, camera);
    }

    public setZoomRatio(request: PtzAbsoluteZoomRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/SetZoomRatio`, request);
    }

    public updateAllCameraConfigurations(request: UpdateAllCameraConfigurationsRequest) {
        return super.post<boolean>(`/api/Camera/UpdateAllCameraConfigurations`, request);
    }

    public updateAllCameraReadOnlyProperties() {
        return super.post<boolean>(`/api/Camera/UpdateAllCameraReadOnlyProperties`, {});
    }

    public updateAllCameraResolutions(request: UpdateAllCameraResolutionsRequest) {
        return super.post<boolean>(`/api/Camera/UpdateAllCameraResolutions`, request);
    }

    public updateAllCameraResolutionsOfType(request: UpdateAllCameraResolutionsOfTypeRequest) {
        return super.post<boolean>(`/api/Camera/UpdateAllCameraResolutionsOfType`, request);
    }

    public updateAllCamerasOfSameType(request: UpdateAllCamerasOfSameTypeRequest) {
        return super.post<boolean>(`/api/Camera/UpdateAllCamerasOfSameType`, request);
    }

    public updateCamera(camera: Camera) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/Camera/UpdateCamera`, camera);
    }

    public updateCameras(camerasToUpdate: Camera[]) {
        return super.post<boolean>(`/api/Camera/UpdateCameras`, camerasToUpdate);
    }

    public zoomInCamera(request: ZoomInCameraRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/ZoomInCamera`, request);
    }

    public zoomOutCamera(request: ZoomOutCameraRequest) {
        return super.post<CameraCommandResult<string>>(`/api/Camera/ZoomOutCamera`, request);
    }
}